module.exports = __webpack_public_path__ + "res/24-img_game_bg.51f049a4de3522e77fd06410fae5010d.png";